__turbopack_context__.v({
  "backdrop": "MarketingShell-module__ld-Nxq__backdrop",
  "brand": "MarketingShell-module__ld-Nxq__brand",
  "brandText": "MarketingShell-module__ld-Nxq__brandText",
  "container": "MarketingShell-module__ld-Nxq__container",
  "footer": "MarketingShell-module__ld-Nxq__footer",
  "footerLink": "MarketingShell-module__ld-Nxq__footerLink",
  "footerLinks": "MarketingShell-module__ld-Nxq__footerLinks",
  "footerRow": "MarketingShell-module__ld-Nxq__footerRow",
  "header": "MarketingShell-module__ld-Nxq__header",
  "link": "MarketingShell-module__ld-Nxq__link",
  "mark": "MarketingShell-module__ld-Nxq__mark",
  "nav": "MarketingShell-module__ld-Nxq__nav",
  "page": "MarketingShell-module__ld-Nxq__page",
  "primary": "MarketingShell-module__ld-Nxq__primary",
});
